import { useEffect, useRef } from 'react';

export function useElementObserver({
  element,
  percent = 100,
  onDetect,
  once = true,
}) {
  const hasTriggeredRef = useRef(false);
  const observerRef = useRef(null);

  useEffect(() => {
    if (!element || typeof onDetect !== 'function') return;

    const target = document.querySelector(element);
    if (!target) return;

    const threshold = Math.min(Math.max(percent / 100, 0), 1);

    observerRef.current = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return;
        if (entry.intersectionRatio < threshold) return;

        if (once && hasTriggeredRef.current) return;

        hasTriggeredRef.current = true;
        onDetect(entry);

        if (once) {
          observerRef.current?.disconnect();
        }
      },
      { threshold },
    );

    observerRef.current.observe(target);

    return () => {
      observerRef.current?.disconnect();
      observerRef.current = null;
    };
  }, [element, percent, onDetect, once]);
}
